import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router-dom'

import get from 'lodash/get'
import defaultTo from 'lodash/defaultTo'

import { ChildProps } from 'react-apollo'
import { InputProps } from '.'

import PageLayout from 'components/layout/pageLayout'
import Head from 'components/layout/head'
import Input from 'components/ui/input'
import Button from 'components/ui/button'
import isNil from 'lodash/isNil'
import pick from 'lodash/pick'

interface ForgotPasswordProps extends ChildProps<InputProps, Response>, RouteComponentProps<any> {
  data: any
}

interface IErrorObject {
  [k: string]: string | null
}

type ForgotPasswordState = {
  errors: IErrorObject | null
  email: string | null
  success: boolean
}

class ForgotPassword extends Component<ForgotPasswordProps, ForgotPasswordState> {
  constructor(props: ForgotPasswordProps) {
    super(props)
    this.state = {
      errors: null,
      success: false,
      ...this.formFields,
    }
  }

  formFields = {
    email: null,
  }

  getVariables = () => {
    const formFields = Object.keys(this.formFields)
    const variables = this.state

    // Filter out non form fields from state object
    return pick(variables, formFields)
  }

  handlePasswordRequest = () => {
    const { mutate } = this.props

    const errors = {
      email: !this.state.email ? 'Error Message.' : null,
    }

    const hasErrors = Object.values(errors).reduce((prev, error) => {
      if (error) return true
      return false
    }, false)

    if (hasErrors) {
      this.setState({ errors })
    } else {
      if (mutate) {
        mutate({
          variables: { ...this.getVariables() },
        })
          .then(res => {
            // Password request was sucessfull
            if (get(res, 'data.forgotPassword')) {
              this.setState({ errors: null, success: true })
            } else {
              this.setState({
                errors: {
                  api: 'Ein Fehler ist aufgetreten.',
                },
              })
            }
          })
          .catch(() => {
            const error = JSON.parse(
              get(this.props, 'result.error.graphQLErrors[0].message.message', null),
            )

            this.setState({
              errors: {
                api: this.translateApiErrorCode(get(error, 'code', undefined)),
              },
              success: false,
            })
          })
      }
    }
  }

  translateApiErrorCode(code: number | undefined) {
    switch (code) {
      case 103:
        return 'Die E-Mail Adresse wurde nicht gefunden.'
      default:
        return 'Ein Fehler ist aufgetreten.'
    }
  }

  getErrorMessage = () => {
    const { errors } = this.state
    const apiError = get(errors, 'api', undefined)

    if (isNil(errors)) {
      return undefined
    }

    if (!isNil(apiError)) {
      return apiError
    } else {
      return 'Pflichtfelder ausfüllen!'
    }
  }

  render() {
    const { errors, email, success } = this.state

    return (
      <PageLayout pageTitle="Passwort vergessen">
        <Head
          headline="Passwort vergessen"
          subheadline="Zurück zur Startseite"
          linkTo="/"
          error={errors ? true : false}
          message={this.getErrorMessage()}
        />

        {success ? (
          <div className="my-65 px-48">
            <p className="font-400 text-15 tracking-0.1 text-black leading-22">
              Ihr Logindaten wurden Ihnen per E-Mail gesendet.
            </p>
          </div>
        ) : (
          <>
            <div className="my-65 px-48">
              <p className="font-400 text-15 tracking-0.1 text-black leading-22">
                Geben Sie Ihre E-Mail-Adresse ein und klicken Sie anschließend auf "Logindaten
                anfordern". Die zugehörigen Logindaten werden dann umgehend an diese Adresse
                versandt.
              </p>
            </div>

            <div className="px-48">
              <div className="flex">
                <div className="w-4/12 flex items-end">
                  <Input
                    type="email"
                    name="email"
                    label="E-Mail Adresse"
                    value={defaultTo(email, '')}
                    leftAlign
                    error={errors && errors.email ? errors.email : undefined}
                    onChange={value => this.setState({ email: String(value) })}
                  />
                </div>
                <div className="w-4/12 ml-30 flex items-end">
                  <Button primary onClick={this.handlePasswordRequest}>
                    Logindaten jetzt anfordern
                  </Button>
                </div>
              </div>
            </div>
          </>
        )}
      </PageLayout>
    )
  }
}

export default ForgotPassword
